export default __webpack_public_path__ + "static/media/Blocks-SDK-logo-h-Blue.9e48af7f.png";